import type { LegendSwatchKind } from "@/shared/components/legend-swatch";

export const RESOLVER_CONFLITO_TITLE = "Resolver Conflito de Alocação";
export const RESOLVER_CONFLITO_GUIDANCE =
  "Escolha como tratar a sobreposição de datas das alocações deste profissional.";
export const REMANEJAR_GUIDANCE =
  "Remaneje o profissional para solucionar a sobreposição de datas.";
export const SELECIONAR_CONFLITO_TITLE = "Selecionar Conflito";

export const CONFLITO_LOAD_ERROR_MESSAGE =
  "Não foi possível carregar os dados do conflito. Tente novamente.";
export const PROFISSIONAIS_LOAD_ERROR_MESSAGE =
  "Não foi possível carregar os profissionais disponíveis. Tente novamente.";
export const PROFISSIONAIS_EMPTY_MESSAGE = "Nenhum profissional encontrado.";
/** Busca sem resultado: mesmo empty state das listagens do Hub (Figma ilu-no-search). */
export const PROFISSIONAIS_SEARCH_EMPTY = {
  title: "Nenhum resultado corresponde à busca.",
  description: "Tente revisar o termo pesquisado",
};

export const OBRA_REQUIRED_MESSAGE = "Selecione a obra para remanejar o profissional.";
export const SUBSTITUTO_REQUIRED_MESSAGE = "Selecione um profissional substituto.";
export const REMANEJAR_JUSTIFICATIVA_REQUIRED_MESSAGE = "Informe a justificativa para confirmar.";

export const COMO_RESOLVER_LABEL = "Como deseja resolver?";
export const QUAL_CONFLITO_LABEL = "Qual conflito deseja resolver?";
export const OPCAO_REMANEJAR_TITLE = "Remanejar Profissional";
export const OPCAO_REMANEJAR_DESCRIPTION =
  "Substitua o profissional em uma das obras para eliminar o conflito de datas.";
export const OPCAO_IGNORAR_TITLE = "Ignorar Conflito";
/** Mesmo texto do Ignorar de Local e Fornecedor: o tratado aparece em verde no cronograma. */
export const OPCAO_IGNORAR_DESCRIPTION =
  "Manter a alocação atual. Informe o motivo e a sobreposição passa a aparecer em verde no cronograma, como conflito tratado.";
export const RECOMENDADO_LABEL = "RECOMENDADO";

export const STEP_SELECIONAR_LABEL = "Selecionar Profissional";
export const OBRA_SECTION_LABEL = "1. SELECIONE A OBRA PARA REMANEJAR O PROFISSIONAL";
export const SUBSTITUTO_SECTION_LABEL = "2. SELECIONE UM PROFISSIONAL SUBSTITUTO";
export const BUSCAR_PROFISSIONAL_PLACEHOLDER = "Buscar Profissional";
export const PERIODO_OBRA_LABEL = "Período da Obra";
export const PERIODO_ALOCADO_LABEL = "Período Alocado";
export const DISPONIVEL_LABEL = "Disponível";
export const INDISPONIVEL_LABEL = "Indisponível";
export const CONFLITO_DESCRICAO_CURTA =
  "Este profissional está alocado em obras distintas com datas sobrepostas no cronograma.";

export const ALOCACAO_SECTION_LABEL = "Alocação de cada profissional";
/** Papel mostrado quando a alocação não tem papel ou a lista de papéis está fora (como na simulação). */
export const PAPEL_FALLBACK = "profissional";

export const IGNORAR_GUIDANCE =
  "Informe uma justificativa para registrar o motivo de manter o profissional alocado em obras com datas sobrepostas.";

/** Máximo de profissionais carregados para a escolha do substituto (com busca). */
export const SUBSTITUTOS_PAGE_SIZE = 50;

/** Legenda da revisão (HU 2040): as situações na ordem da especificação e Hoje; Cancelada só com o indicador ligado. */
export const REVISAO_LEGEND: { key: LegendSwatchKind; label: string }[] = [
  { key: "planejamento", label: "Planejamento" },
  { key: "obra", label: "Obra" },
  { key: "fechamento", label: "Fechamento" },
  { key: "transferida", label: "Obra Transferida" },
  { key: "cancelada", label: "Cancelada" },
  { key: "indisponibilidade", label: "Indisponibilidade" },
  { key: "hoje", label: "Hoje" },
];

/** Na simulação a legenda segue o Figma (9497:109954): Obra Transferida primeiro. */
const ORDEM_LEGEND_SIMULACAO: LegendSwatchKind[] = [
  "transferida",
  "planejamento",
  "obra",
  "fechamento",
  "cancelada",
  "indisponibilidade",
  "hoje",
];
const ITEM_LEGEND = new Map(REVISAO_LEGEND.map((item) => [item.key, item]));
export const REVISAO_LEGEND_SIMULACAO = ORDEM_LEGEND_SIMULACAO.flatMap(
  (key) => ITEM_LEGEND.get(key) ?? [],
);
